import Carousel from './Carousel';
import CarouselItem from './CarouselItem';

Carousel.Item = CarouselItem;

export default Carousel;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/carousel/index.js
// module id = 345
// module chunks = 0